// src/components/AssetUploadDropzone.js

import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function AssetUploadDropzone({ onSetFiles }) {
  const onDrop = (acceptedFiles) => {
    const filesArray = acceptedFiles.map((file) => ({
      uploadId: file.name + '-' + Date.now(),
      name: file.name,
      size: file.size,
      sourceUrl: URL.createObjectURL(file),
    }));
    onSetFiles(filesArray);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const { t } = useTranslation();

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: '2px dashed #ccc',
        padding: '16px',
        textAlign: 'center',
        cursor: 'pointer',
      }}
    >
      <input {...getInputProps()} />

      <>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            style={{
              backgroundColor: "#E3EEF9",
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#138085"
            >
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z" />
            </svg>
          </Box>

          <Stack direction="column" justifyContent="center" alignItems="center" spacing={0.7} >
            <Typography variant="body1" style={{ color: '#138085' }}>{t('selectImage')}</Typography>
            <Typography variant="body1">{t('selectFromGallery')}</Typography>
          </Stack>
        </Box>
      </>
    </Box>
  );
}
